export default "__VITE_ASSET__Cf9JULTL__"